import { NavLink } from 'react-router-dom'
import {
  Activity,
  Archive,
  Bell,
  Boxes,
  Bug,
  Clock,
  History,
  Layers,
  LayoutDashboard,
  Server,
  Settings,
  Signal,
  Sliders,
  Zap,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/nodes', label: 'Nodes', icon: Server },
  { to: '/stacks', label: 'Stacks', icon: Layers },
  { to: '/services', label: 'Services', icon: Boxes },
  { to: '/health', label: 'Health', icon: Activity },
  { to: '/network', label: 'Network', icon: Signal },
  { to: '/alerts', label: 'Alerts', icon: Bell },
  { to: '/errors', label: 'Errors', icon: Bug },
  { to: '/backups', label: 'Backups', icon: Archive },
  { to: '/settings/notifications', label: 'Settings', icon: Settings },
  { to: '/settings/rules', label: 'Rules', icon: Sliders },
  { to: '/settings/maintenance', label: 'Maintenance', icon: Clock },
  { to: '/settings/power', label: 'Power tariff', icon: Zap },
  { to: '/audit', label: 'Audit log', icon: History },
] as const

export function Sidebar() {
  return (
    <aside className="w-60 shrink-0 border-r border-border bg-card/40 px-3 py-6">
      <div className="px-2 pb-6">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-primary/15 text-primary grid place-items-center font-bold">
            Z
          </div>
          <span className="text-lg font-semibold tracking-tight">Zeus</span>
        </div>
      </div>
      <nav className="flex flex-col gap-1">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-accent text-accent-foreground'
                  : 'text-muted-foreground hover:bg-accent/60 hover:text-foreground',
              )
            }
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
